const constants = {
  mapKey: 'XRPBZ-GSQKQ-G3U5J-4NSC4-MXL4Q-Q7FFJ' // 前段用外露key ,成对的 后端用这个key-企业级别 S3DBZ-XUOCX-RDC4K-77XXV-RP262-NNBEB
}
export default constants
